import { request } from "./backend_util";

export type Team = {
    id: number;
    name: string;
    slug: string;
    leadUserId?: number;
    slackChannel?: string;
    isActive: boolean;
    lead?: {
        id: number;
        name: string;
        username: string;
    };
    users?: Array<{
        id: number;
        name: string;
        username: string;
        title?: string;
    }>;
    userCount?: number;
}

export type CreateTeamRequest = {
    name: string;
    leadUserId?: number;
    slackChannel?: string;
    isActive?: boolean;
}

export type UpdateTeamRequest = Partial<CreateTeamRequest>;

export type AssignUsersRequest = {
    userIds: number[];
}

export const teamsBackend = {
    // Get all teams with optional filtering
    getTeams: request<Team[]>('GET', '/teams'),
    
    // Get teams with query parameters
    getTeamsFiltered: (activeOnly?: boolean, search?: string) => {
        const params = new URLSearchParams();
        if (activeOnly !== undefined) params.set('active', activeOnly.toString());
        if (search) params.set('search', search);
        
        const queryString = params.toString();
        const url = queryString ? `/teams?${queryString}` : '/teams';
        return request<Team[]>('GET', url)();
    },

    // Get specific team by ID
    getTeam: (id: number) => request<Team>('GET', `/teams/${id}`)(),

    // Get team by slug
    getTeamBySlug: (slug: string) => request<Team>('GET', `/teams/slug/${slug}`)(),

    // Create new team (admin only)
    createTeam: request<Team>('POST', '/teams'),

    // Update team (admin only)
    updateTeam: (id: number) => request<Team>('PUT', `/teams/${id}`),

    // Delete team (admin only)
    deleteTeam: (id: number) => request<void>('DELETE', `/teams/${id}`)(),

    // Deactivate team (admin only)
    deactivateTeam: (id: number) => request<Team>('PUT', `/teams/${id}/deactivate`)(),

    // Assign users to team (admin only)
    assignUsersToTeam: (teamId: number) => request<Team>('POST', `/teams/${teamId}/users`),

    // Remove users from their teams (admin only)
    removeUsersFromTeams: request<void>('DELETE', '/teams/users')
};
